import Slider from 'react-slick';
/* @ts-ignore */
const SliderComponent = !!Slider.default ? Slider.default : Slider //hotfix: https://github.com/akiran/react-slick/issues/2206#issuecomment-1961173249

import { Box, Divider } from 'src/components/mui';
import { Tip } from './components/Tip';
import { getItems, settings } from './config';
//@ts-ignore
import React, { useMemo } from 'react';

type Props = {
  translation?: any;
};

export const TipsCarousel = ({ translation }: Props) => {
  const items = useMemo(() => getItems(translation), [translation]);

  return (
    <Box sx={{ maxHeight: '200px' }}>
      <Divider
        sx={{
          color: '#fff',
          '&::before, &::after': {
            borderColor: '#fff'
          },
          mb: 2
        }}
      >
        {translation?.tips || 'Tips'}
      </Divider>
      <SliderComponent {...settings}>
        {items.map((i, index) => (
          <Tip key={index} src={i.src} label={i.label} />
        ))}
      </SliderComponent>
    </Box>
  );
};
